import { mobilePlatformsEnums } from './reusableFields/fields'

export const getObjectStoreUrl = ({ facebookClientApps, applicationId, platform }) => {
  const foundClientApp = facebookClientApps.find(app => app.id === applicationId)

  const platformsDictionary = {
    [mobilePlatformsEnums.iOS]: 'itunes',
    [mobilePlatformsEnums.Android]: 'google_play'
  }

  return foundClientApp?.object_store_urls?.[platformsDictionary[platform]] || ''
}
